// extracted by mini-css-extract-plugin
export default {"srOnly":"_2H0_0","couponContainer":"_3pS0R","headerTitle":"_3Qz1T","headerSubtitle":"_2N8Br","couponText":"_2VsIf"};